import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/dashboard/_layout/pending-approvals/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/dashboard/pending-approvals/price",
      search: (prev) => prev,
    })
  },
})
